import React, { useCallback } from 'react';
import FormInput from 'components/Input/FormInput';
import style from './PriceTypeField.module.scss';

interface IPriceTypeField {
	changePriceType: (value: Nullable<string>) => void;
	isUsedCustomerPriceType: boolean;
}

const PriceTypeField: React.FC<IPriceTypeField> = ({ changePriceType, isUsedCustomerPriceType }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			changePriceType(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[changePriceType],
	);

	return (
		<FormInput
			testId="PriceTypeField"
			className={style.input}
			name="priceType"
			label="priceTypeLabel"
			getValueFromEvent={handleChange}
			disabled={isUsedCustomerPriceType}
		/>
	);
};

export default React.memo(PriceTypeField);
